module.exports = __webpack_public_path__ + "static/media/CircularStd-Bold.6baed2bf.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CircularStd-Bold.otf
// module id = 729
// module chunks = 0